"use client";

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from "react";
import IllustrationPrimitive, { SIZE_OPTIONS } from "../primitives/IllustrationPrimitive";
const Illustration = ({
  size = SIZE_OPTIONS.MEDIUM,
  role = "presentation",
  ...props
}) => /*#__PURE__*/React.createElement(IllustrationPrimitive, _extends({}, props, {
  size: size,
  role: role
}));
export default Illustration;